import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { CountryFilterType } from '@/store/filterSlice'
import { StoreHealthResponseModel } from '@/types/clarity/response'

export const getStoreHealthCheck = async (
  startDate: string,
  endDate: string,
  country: CountryFilterType
): Promise<StoreHealthResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/store-health-check`, {
      params: {
        start_month: startDate,
        end_month: endDate,
        country,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
